<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import VueDropify from "vue-dropify";
import Drawer from "@/components/drawer";
import VLazyImage from "v-lazy-image/v2";
import draggable from "vuedraggable";

// Custom Components
import TVChannel from "@/components/hotel/tvChannel.vue";
import UserService from "@/helpers/APIService/user.service";
import Middleware from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    VueDropify,
    Drawer,
    TVChannel,
    VLazyImage,
    draggable,
  },
  props: {
    currentProps: Object,
  },
  data() {
    return {
      editable: true,
      isDragging: false,
      title: "Near By Place",
      table: {
        categoryTableData: [],
        nearByPlaceTableData: [],
      },
      selectedCategory: "",
      // Category related data
      isCategoryDataLoad: true,
      category: {
        name: "",
        image: null,
        is_active: true,
      },
      imgUrl: null,
      categoryTitle: "Add New TV Category",
      categorySubmitted: false,
      isCategoryBtnLoading: false,
      isCategoryEdit: false,
      categoryId: "",
      categoryOption: [{ value: "all", text: "All", disabled: false }],

      // Near by places related data
      categoryIdForPlace: "",
      isTVChannelDataLoad: true,
      openTvChannelDrawer: false,
      isTVChannelEdit: false,
      imagePreView: [],
    };
  },
  computed: {
    ...authComputed,
    tvChannelProps() {
      return {
        selectedTVChannel: this.selectedTVChannel,
        isEdit: this.isTVChannelEdit,
      };
    },
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost",
      };
    },
  },

  mounted() {
    this.getTVChannelCategoryList();
  },
  methods: {
    /** CATEGORY RELATED METHODS */

    // Method is use for get list of tv channel
    async getTVChannelCategoryList() {
      try {
        const response = await UserService.getTvChannelCategory();
        this.table.categoryTableData = response;
        response.map((item) => {
          this.categoryOption.push({
            text: item.name,
            value: item.id,
            disabled: false,
          });
        });
        this.isCategoryDataLoad = false;
      } catch (error) {
        errorHandler(error);
      }
    },
    // Method is use for open category modal
    openCategoryModal() {
      this.$bvModal.show("category-modal");
    },
    // Method is fro maintained edit category data
    editCategory(data) {
      this.isCategoryEdit = !this.isCategoryEdit;
      this.$bvModal.show("category-modal");
      this.categoryId = data.id;
      this.categoryTitle = "Update TV Category";
      this.category.name = data.name;
      this.category.image = data.image;
      this.category.is_active = data.is_active;
    },
    // Method is use add new category on button ok click
    handleCategoryOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleCategorySubmit();
    },
    // Method is use add new category
    async handleCategorySubmit() {
      this.categorySubmitted = true;
      this.isCategoryBtnLoading = true;
      this.$v.$touch();
      if (this.$v.category.$invalid) {
        this.isCategoryBtnLoading = false;
        return;
      } else {
        const categoryData = new FormData();
        if (typeof this.category.image === "string") {
          delete this.category.image;
        }
        categoryData.append("hotel", this.hotel.id);
        Object.keys(this.category).map((key) => {
          categoryData.append(key, this.category[key]);
        });
        if (this.imgUrl !== null) {
          categoryData.append("image", this.imgUrl);
        }
        if (this.isCategoryEdit !== false) {
          try {
            const response = await UserService.updateTvChannelCategory(
              this.categoryId,
              categoryData
            );
            this.table.categoryTableData = this.table.categoryTableData.map(
              (item) => {
                if (item.id === response.id) {
                  item = response;
                }
                this.categoryOption = this.categoryOption.map((c_op) => {
                  if (c_op.value == response.id) {
                    c_op = { ...c_op, value: response.id, text: response.name };
                  }
                  return c_op;
                });
                return item;
              }
            );
            this.categoryOption = [...new Set(this.categoryOption)];
            this.$bvModal.hide("category-modal");
            Middleware.notification("Successfully updated !!", "success");

            this.isCategoryBtnLoading = false;
            this.resetCategoryModal();
          } catch (error) {
            this.isCategoryBtnLoading = false;
            errorHandler(error);
          }
        } else {
          try {
            const response = await UserService.addTvChannelCategory(
              categoryData
            );
            this.$bvModal.hide("category-modal");
            Middleware.notification("Successfully added !!", "success");

            this.isCategoryBtnLoading = false;
            this.table.categoryTableData.push(response);
            this.categoryOption.push({
              text: response.name,
              value: response.id,
              disabled: false,
            });

            this.resetCategoryModal();
          } catch (error) {
            this.isCategoryBtnLoading = false;
            errorHandler(error);
          }
        }
      }
    },
    // Method is use for maintained change image event
    changeCategoryImage(event) {
      this.imgUrl = event[0] == undefined ? null : event[0];
    },
    // Method is use for reset modal
    resetCategoryModal() {
      this.category = {
        name: "",
        image: "",
        is_active: true,
      };
      this.categorySubmitted = false;
      this.isCategoryEdit = false;
      this.categoryTitle = "Add New TV Category";
      this.isCategoryBtnLoading = false;
    },
    // Method is use for delete category
    deleteCategory(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          UserService.deleteTvChannelCategory(id).then(
            () => {
              this.table.categoryTableData =
                this.table.categoryTableData.filter((item) => {
                  return item.id !== id;
                });
              this.categoryOption = this.categoryOption.filter(
                (c_op) => c_op.value !== id
              );
              Middleware.notification("Successfully deleted !!", "success");
            },
            (error) => {
              errorHandler(error);
            }
          );
        }
      });
    },
    // method is use for cancel submit form
    cancelCategorySubmit() {
      this.$bvModal.hide("category-modal");
      this.resetCategoryModal();
    },
    // Method is use for change category position change
    onCategoryPositionChange: async function ($evt) {
      try {
        if ($evt.moved.element == undefined) {
          Middleware.notification("You can't move this one !!", "info");
        } else {
          const categoryData = new FormData();
          categoryData.append("priority_order", $evt.moved.newIndex + 1);
          const response = await UserService.updateTvChannelCategory(
            $evt.moved.element.id,
            categoryData
          );
          Middleware.notification("Positions changed !!", "success");
        }
      } catch (error) {
        errorHandler(error);
      }
    },
    //Method is use for change category status
    async changeCategoryStatus(id, data) {
      try {
        const response = await UserService.updateTvChannelCategory(id, data);
        Middleware.notification("Status change successfully !!", "success");
      } catch (error) {
        errorHandler(error);
      }
    },

    /** TV Channel RELATED METHOD **/

    // Method is used to get Near by place by ID
    async getTVChannelListData(id) {
      try {
        this.isTVChannelDataLoad = true;
        let query = "";
        if (id !== "all" && id !== undefined) {
          if (id == "tab" && this.table.categoryTableData.length !== 0) {
            this.selectedCategory = this.table.categoryTableData[0].id;
            query =
              "?tv_channel_category=" + this.table.categoryTableData[0].id;
          } else {
            query = "?tv_channel_category=" + id;
          }
        }
        const response = await UserService.getTvChannelList(query);
        this.table.nearByPlaceTableData = response;
        this.isTVChannelDataLoad = false;
      } catch (error) {
        errorHandler(error);
      }
    },
    // Method is use for open and close drawer
    tvChannelForm() {
      if (this.openTvChannelDrawer == true) {
        this.selectedTVChannel = null;
        this.isTVChannelEdit = false;
      }
      this.openTvChannelDrawer = !this.openTvChannelDrawer;
    },
    // Method is use for update live data
    tvChannelAddedUpdated(tvChannel) {
      if (this.isTVChannelEdit == true) {
        this.table.nearByPlaceTableData = this.table.nearByPlaceTableData.map(
          (item) => {
            if (item.id === tvChannel.id) {
              item = tvChannel;
            }
            return item;
          }
        );
        Middleware.notification("Successfully updated !!", "success");
      } else {
        this.table.nearByPlaceTableData.push(tvChannel);
        Middleware.notification("Successfully added !!", "success");
      }
      this.tvChannelForm();
    },
    // Method is used to Add near by place
    saveAndAddNewTVChannel(tvChannel) {
      this.table.nearByPlaceTableData.push(tvChannel);
      Middleware.notification("Successfully added !!", "success");
    },
    // Method is use for update info and services based on ID
    editTVChannel(data) {
      this.selectedTVChannel = data;
      this.isTVChannelEdit = true;
      this.tvChannelForm();
    },
    // Method is use for delete info and service
    deleteTVChannel(id, index) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          UserService.deleteTVChannel(id).then(
            () => {
              this.table.nearByPlaceTableData.splice(index, 1);
              Middleware.notification("Successfully deleted !!", "warning");
            },
            (error) => {
              errorHandler(error);
            }
          );
        }
      });
    },
    // Method is use for change place status
    changeTVChannelStatus(id, data) {
      UserService.updateTVChannel(id, data)
        .then((tvChannel) => {
          Middleware.notification("Place status changed !!", "success");
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is use for change place as Favorite
    changeTVChannelFavorite(id, data) {
      UserService.updateTVChannel(id, data)
        .then((tvChannel) => {
          Middleware.notification("Place added as favorite !!", "success");
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is use for change category position change
    onTVChannelPositionChange: async function ($evt) {
      try {
        if ($evt.moved.element == undefined) {
          Middleware.notification("You can't move this one !!", "info");
        } else {
          const categoryData = new FormData();
          categoryData.append("priority_order", $evt.moved.newIndex + 1);
          const response = await UserService.updateTVChannel(
            $evt.moved.element.id,
            categoryData
          );
          Middleware.notification("positions changed !!", "success");
        }
      } catch (error) {
        errorHandler(error);
      }
    },
  },
  validations: {
    category: {
      name: {
        required,
      },
      image: {
        required: requiredIf(function () {
          if (this.isCategoryEdit == false && this.imgUrl == null) {
            return true;
          }
        }),
      },
    },
  },
};
</script>

<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div role="tablist">
          <!-- Category Data -->
          <b-card no-body class="mb-3">
            <b-card-header header-tag="header" role="tab" class="py-0">
              <div class="d-flex align-items-center justify-content-between">
                <div class="w-100 py-3" v-b-toggle.category>
                  <h6 class="m-0 fs-5">
                    <a class="text-dark" href="javascript: void(0);"
                      >Category</a
                    >
                  </h6>
                </div>
                <div class="collapse-120">
                  <button
                    class="btn btn-primary float-end"
                    @click="openCategoryModal"
                  >
                    <i class="fas fa-plus me-2"></i> Add New
                  </button>
                </div>
              </div>
            </b-card-header>
            <b-collapse
              id="category"
              visible
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text>
                  <div class="table-responsive">
                    <table class="table table-hover mb-0 common-table">
                      <thead class="table-light">
                        <tr>
                          <th>Name</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <draggable
                        v-model="table.categoryTableData"
                        v-bind="dragOptions"
                        @change="onCategoryPositionChange"
                        tag="tbody"
                      >
                        <tr
                          v-for="(data, index) in table.categoryTableData"
                          :key="index"
                        >
                          <td @click="editCategory(data)">
                            <div class="d-flex align-items-center">
                              <v-lazy-image
                                :key="data.id"
                                class="rounded-circle picture-img"
                                :src="data.image"
                                alt=""
                                src-placeholder="../../../assets/images/placeholder.png"
                              />
                              <span class="text-truncate ms-2 d-block w-75">{{
                                data.name
                              }}</span>
                            </div>
                          </td>
                          <td>
                            <div class="form-check form-switch">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="data.is_active"
                                @click="
                                  changeCategoryStatus(data.id, {
                                    is_active: !data.is_active,
                                  })
                                "
                              />
                            </div>
                          </td>
                          <td>
                            <div class="d-flex align-items-center">
                              <i
                                class="fas fa-pencil-alt text-success fs-5"
                                title="edit record"
                                @click="editCategory(data)"
                              ></i>
                              <i
                                class="mdi mdi-trash-can ms-2 fs-5 text-danger fs-5"
                                title="delete record"
                                @click="deleteCategory(data.id, index)"
                              >
                              </i>
                              <i
                                v-if="table.categoryTableData.length > 1"
                                class="ms-2 fa fa-align-justify cursor-move"
                                v-b-popover.hover="'Move category'"
                              ></i>
                            </div>
                          </td>
                        </tr>
                      </draggable>
                    </table>
                  </div>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <!-- Place Data -->
          <b-card no-body class="mb-3">
            <b-card-header
              header-tag="header"
              role="tab"
              @click="getTVChannelListData('tab')"
              class="py-0"
            >
              <div class="d-flex align-items-center justify-content-between">
                <div class="w-100 py-3" v-b-toggle.place>
                  <h6 class="m-0 fs-5">
                    <a class="text-dark" href="javascript: void(0);"
                      >TV Channel</a
                    >
                  </h6>
                </div>
                <div class="collapse-120">
                  <button
                    class="btn btn-primary float-end"
                    @click="tvChannelForm"
                  >
                    <i class="fas fa-plus me-2"></i> Add New
                  </button>
                </div>
              </div>
            </b-card-header>
            <b-collapse
              id="place"
              visible
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text>
                  <div class="d-flex align-items-center mb-3">
                    <label class="mb-0 me-3"> Category</label>
                    <b-form-select
                      class="form-select w-25"
                      id="category"
                      type="text"
                      autocomplete="off"
                      v-model="selectedCategory"
                      :options="categoryOption"
                      @change="getTVChannelListData($event)"
                    >
                    </b-form-select>
                  </div>
                  <div class="table-responsive">
                    <table class="table table-hover mb-0 common-table">
                      <thead class="table-light">
                        <tr>
                          <th>Name</th>
                          <th>Number</th>
                          <th>Status</th>
                          <th>Favorite</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody v-if="isTVChannelDataLoad">
                        <tr v-for="item in 10" :key="item">
                          <td
                            class="placeholder-glow"
                            v-for="no in 5"
                            :key="no"
                          >
                            <span
                              class="placeholder w-100 placeholder-lg"
                            ></span>
                          </td>
                        </tr>
                      </tbody>

                      <tbody v-else>
                        <tr
                          v-for="(data, index) in table.nearByPlaceTableData"
                          :key="index"
                        >
                          <td @click="editTVChannel(data)">
                            <div class="d-inline-flex align-items-center">
                              <v-lazy-image
                                :key="data.id"
                                :src="data.image"
                                alt=""
                                class="rounded-circle picture-img"
                                src-placeholder="../../../assets/images/placeholder.png"
                              />
                              <span class="text-truncate ms-2 d-block w-75">{{
                                data.name
                              }}</span>
                            </div>
                          </td>
                          <td @click="editTVChannel(data)">
                            {{
                              data.channel_number !== null
                                ? data.channel_number
                                : "-"
                            }}
                          </td>
                          <td>
                            <div class="form-check form-switch">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                v-b-popover.hover="'Active Place'"
                                v-model="data.is_active"
                                @click="
                                  changeTVChannelStatus(data.id, {
                                    is_active: !data.is_active,
                                  })
                                "
                              />
                            </div>
                          </td>
                          <td>
                            <div class="form-check form-switch">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                v-b-popover.hover="'Active Place'"
                                v-model="data.is_favorite"
                                @click="
                                  changeTVChannelFavorite(data.id, {
                                    is_favorite: !data.is_favorite,
                                  })
                                "
                              />
                            </div>
                          </td>
                          <td>
                            <div class="d-flex align-items-center">
                              <i
                                class="fas fa-pencil-alt text-success fs-5 m-2"
                                v-b-popover.hover="'Edit Place'"
                                @click="editTVChannel(data)"
                              ></i>
                              <i
                                class="mdi mdi-trash-can fs-5 text-danger fs-5"
                                v-b-popover.hover="'Delete Place'"
                                @click="deleteTVChannel(data.id, index)"
                              >
                              </i>
                              <!-- <i
                                v-if="table.nearByPlaceTableData.length > 1"
                                class="ms-2 fa fa-align-justify cursor-move"
                                v-b-popover.hover="'Move category'"
                              ></i> -->
                            </div>
                          </td>
                        </tr>
                      </tbody>
                      <tbody
                        v-if="
                          !isTVChannelDataLoad &&
                          table.nearByPlaceTableData.length == 0
                        "
                      >
                        <tr>
                          <td colspan="9" class="text-center">
                            <img
                              src="@/assets/images/empty.svg"
                              class="img-fluid"
                              alt=""
                            />
                            <p>
                              <span class="text-secondary">No Data Found</span>
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </div>
    </div>

    <!-- Model is for add and update category -->
    <b-modal
      id="category-modal"
      centered
      :title="categoryTitle"
      hide-footer
      title-class="font-18"
      @hidden="resetCategoryModal"
    >
      <form ref="form" @submit.stop.prevent="handleCategorySubmit">
        <b-form-group label="Name" label-for="name-input">
          <p slot="label">Category Name <span class="text-danger">*</span></p>
          <b-form-input
            id="name-input"
            v-model="category.name"
            placeholder="category name"
            autocomplete="off"
            type="text"
            :class="{
              'is-invalid': categorySubmitted && $v.category.name.$error,
            }"
          ></b-form-input>
          <div v-if="categorySubmitted" class="invalid-feedback">
            <span v-if="!$v.category.name.required"
              >Category name is required.</span
            >
          </div>
        </b-form-group>
        <b-form-group
          label="thumbnail Image"
          label-for="thumbnail Image-input"
          class="mt-2"
        >
          <p slot="label">
            Category thumbnail Image <span class="text-danger">*</span>
          </p>
          <VueDropify
            @upload="changeCategoryImage($event)"
            :src="category.image !== null ? category.image : ''"
            message="Drop image here or click to select"
            id="image"
            class="mb-3"
            :class="{
              'is-invalid': categorySubmitted && $v.category.image.$error,
            }"
          />
          <div v-if="categorySubmitted" class="invalid-feedback">
            <span v-if="!$v.category.image.required">Image is required.</span>
          </div>
        </b-form-group>
        <div class="row">
          <div class="col-md-12 mt-1">
            <b-button
              class="float-end ms-2"
              variant="outline-primary"
              type="reset"
              @click="cancelCategorySubmit"
              >Cancel
            </b-button>
            <b-button
              class="float-end ms-2"
              variant="outline-primary"
              @click="handleCategoryOk"
              :class="{ disabled: isCategoryBtnLoading }"
            >
              <i
                v-if="isCategoryBtnLoading"
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
              ></i>
              {{ isCategoryEdit ? "Update" : "Save" }}
            </b-button>
          </div>
        </div>
      </form>
    </b-modal>

    <!-- Drawer is for add and update tv channels -->
    <Drawer
      @close="tvChannelForm"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="openTvChannelDrawer">
        <TVChannel
          :currentProps="tvChannelProps"
          @submitted="tvChannelAddedUpdated"
          @cancelSubmit="tvChannelForm"
          @saveAndAddNew="saveAndAddNewTVChannel"
        />
      </div>
    </Drawer>
  </div>
</template>
